import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import BookConsultation from './pages/BookConsultation';

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/book-a-free-consultation" element={<BookConsultation />} />
        <Route path="/book-a-free-consulation" element={<Navigate to="/book-a-free-consultation" replace />} />
      </Routes>
    </Layout>
  );
}

export default App;
